/**
 * Date Format
 * JST形式の日付のフォーマットを変換
 */
import VueDateFormat from './directive'

export default {
  install(Vue, options) {

    Vue.directive('date-format', VueDateFormat)
  }
}


// WEBPACK FOOTER //
// ./src/plugins/dateFormat/index.js